export const MESSAGE_NOT_FOUND = 'No results found. Please enter a more precise address or expand your search criteria for better results.'
export const MESSAGE_ERROR = 'SOMETHING WENT WRONG. TRY AGAIN LATER'
export const MESSAGE_NO_DATA = 'No info added yet'
export const PHONE = {
    format: 'The phone must have a correct format',
    required: 'The phone is required'
}
